var React = require('react');

function UlBulletpointInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"IconsBulletpoint"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("line",{"x1":"1.5","y1":"10","x2":"18","y2":"10","stroke":"#FFCC00","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("circle",{"stroke":"#FFCC00","strokeWidth":"3","fill":"#FFFFFF","cx":"22","cy":"10","r":"8.5","key":1})])]);
}

UlBulletpointInline.defaultProps = {"width":"32px","height":"20px","viewBox":"0 0 32 20","version":"1.1"};

module.exports = UlBulletpointInline;

UlBulletpointInline.default = UlBulletpointInline;
